export enum OrgManagerPermType {
  VIEW_ORG = 'org:view',
  CREATE_ORG = 'org:create',
  EDIT_ORG = 'org:edit',
  DELETE_ORG = 'org:delete',
  MANAGE_ORG_SETTINGS = 'org:manage_settings',
}

export enum ModulemanagerPermType {
  VIEW_MODULE = 'module:view',
  ASSIGN_MODULES = 'module:assign',
}

export enum SystemLogPermType {
  VIEW_SYSTEM_LOG = 'system:log:view',
  EXPORT_SYSTEM_LOG = 'system:log:export',
}

export enum SubscriptionPermType {
  VIEW_SUBSCRIPTION = 'subscription:view',
  MANAGE_SUBSCRIPTION = 'subscription:manage',
}

export enum UserPermType {
  CREATE_USER = 'user:create',
  VIEW_USER = 'user:view',
  EDIT_USER = 'user:edit',
  DELETE_USER = 'user:delete',
}

export enum PatientPermType {
  VIEW_PATIENT = 'patient:view',
  CREATE_PATIENT = 'patient:create',
  EDIT_PATIENT = 'patient:edit',
  DELETE_PATIENT = 'patient:delete',
}

export enum PharmacyPermType {
  VIEW_PHARMACY = 'pharmacy:view',
  CREATE_PHARMACY = 'pharmacy:create',
  EDIT_PHARMACY = 'pharmacy:edit',
  DELETE_PHARMACY = 'pharmacy:delete',
  MANAGE_STOCK = 'pharmacy:stock:manage',
  DISPENSE_PRESCRIPTION = 'pharmacy:dispense',
}

export enum PrescriptionPermType {
  VIEW_PRESCRIPTION = 'prescription:view',
  CREATE_PRESCRIPTION = 'prescription:create',
  EDIT_PRESCRIPTION = 'prescription:edit',
  DELETE_PRESCRIPTION = 'prescription:delete',
  MANAGE_FAVORITES = 'prescription:manage_favorites',
  MANAGE_RECENTS = 'prescription:manage_recents',
}

export enum LeadPermType {
  VIEW_LEAD = 'lead:view',
  VIEW_OWN_LEAD = 'lead:view:own',
  CREATE_LEAD = 'lead:create',
  EDIT_LEAD = 'lead:edit',
  EDIT_LEAD_NON_CORE = 'lead:edit_non_core',
  DELETE_LEAD = 'lead:delete',
  ASSIGN_LEAD = 'lead:assign',
  CREATE_ACTIVITY = 'lead:activity:create',
  VIEW_ACTIVITY = 'lead:activity:view',
  CONVERT_LEAD = 'lead:convert',
}

export enum ServicePermType {
  VIEW_SERVICE = 'service:view',
  CREATE_SERVICE = 'service:create',
  EDIT_SERVICE = 'service:edit',
  DELETE_SERVICE = 'service:delete',
  MANAGE_FAVORITES = 'service:manage_favorites',
  MANAGE_RECENTS = 'service:manage_recents',
}

export enum PremiumPermType {
  BULK_OPERATIONS = 'premium:bulk',
  DIRECT_CALL = 'premium:call',
  DIRECT_EMAIL = 'premium:email',
  FAVORITES_RECENTS = 'premium:favorites_recents',
}

export enum PatientEmrPermType {
  VIEW_EMR = 'emr:view',
  CREATE_EMR = 'emr:create',
  EDIT_EMR = 'emr:edit',
  DELETE_EMR = 'emr:delete',
  EDIT_VITALS = 'emr:vitals:edit',
  EDIT_CLINICAL_NOTES = 'emr:clinical_notes:edit',
  CREATE_DIAGNOSIS = 'emr:diagnosis:create',
  CREATE_PRESCRIPTION = 'emr:prescription:create',
  CREATE_SERVICE = 'emr:service:create',
  START_EMR = 'emr:start',
}

export enum AppointmentPermType {
  VIEW_APPOINTMENT = 'appointment:view',
  VIEW_OWN_APPOINTMENT = 'appointment:view:own',
  CREATE_APPOINTMENT = 'appointment:create',
  EDIT_APPOINTMENT = 'appointment:edit',
  DELETE_APPOINTMENT = 'appointment:delete',
  STATUS_CHANGE_APPOINTMENT = 'appointment:status:change',
}

export enum MarketingPermType {
  CREATE_CAMPAIGN = 'marketing:campaign:create',
  VIEW_CAMPAIGN = 'marketing:campaign:view',
  SEND_CAMPAIGN = 'marketing:campaign:send',
}

export enum SettingsPermType {
  VIEW_APPOINTMENT_SETTINGS = 'settings:appointment:view',
  MANAGE_APPOINTMENT_SETTINGS = 'settings:appointment:manage',

  VIEW_BILLING_SETTINGS = 'settings:billing:view',
  MANAGE_BILLING_SETTINGS = 'settings:billing:manage',

  VIEW_CLINICAL_SETTINGS = 'settings:clinical:view',
  MANAGE_CLINICAL_SETTINGS = 'settings:clinical:manage',

  VIEW_COMMUNICATION_SETTINGS = 'settings:communication:view',
  MANAGE_COMMUNICATION_SETTINGS = 'settings:communication:manage',

  VIEW_DOCUMENT_SETTINGS = 'settings:document:view',
  MANAGE_DOCUMENT_SETTINGS = 'settings:document:manage',

  VIEW_GENERAL_SETTINGS = 'settings:general:view',
  MANAGE_GENERAL_SETTINGS = 'settings:general:manage',

  VIEW_INTEGRATION_SETTINGS = 'settings:integration:view',
  MANAGE_INTEGRATION_SETTINGS = 'settings:integration:manage',

  VIEW_PHARMACY_SETTINGS = 'settings:pharmacy:view',
  MANAGE_PHARMACY_SETTINGS = 'settings:pharmacy:manage',

  VIEW_ROLE_SETTINGS = 'settings:role:view',
  MANAGE_ROLE_SETTINGS = 'settings:role:manage',

  VIEW_SECURITY_SETTINGS = 'settings:security:view',
  MANAGE_SECURITY_SETTINGS = 'settings:security:manage',

  VIEW_FEATURES_SETTINGS = 'settings:features:view',
  MANAGE_FEATURES_SETTINGS = 'settings:features:manage',

  VIEW_TAX_SETTINGS = 'settings:tax:view',
  MANAGE_TAX_SETTINGS = 'settings:tax:manage',
}

export enum ReportPermType {
  VIEW_REPORT = 'report:view',
  GENERATE_REPORT = 'report:generate',
}

export enum AuditLogPermType {
  VIEW_AUDIT_LOG = 'audit:log:view',
  EXPORT_AUDIT_LOG = 'audit:log:export',
}

export enum DataPermType {
  EXPORT_DATA = 'data:export',
  RESTORE_DATA = 'data:restore',
}

export enum TeleMedicinePermType {
  START_VIDEO_CONSULTATION = 'consult:video:start',
  SCHEDULE_VIDEO_CONSULTATION = 'consult:video:schedule',
}

export enum CommunicationPermType {
  SEND_EMAIL = 'communication:email:send',
  SEND_SMS = 'communication:sms:send',
  SEND_WHATSAPP = 'communication:whatsapp:send',
  MANAGE_EMAIL_TEMPLATES = 'communication:email:manage_templates',
  READ_LOGS = 'communication:logs:read',
}

export enum RoleManagerPermType {
  VIEW_ROLES = 'role:view',
  CREATE_ROLES = 'role:create',
  ASSIGN_ROLES = 'role:assign',
}

export enum DocumentPermType {
  UPLOAD_DOCUMENT = 'document:upload',
  VIEW_DOCUMENT = 'document:view',
}

export enum InvoicePermType {
  CREATE_INVOICE = 'invoice:create',
  VIEW_INVOICE = 'invoice:view',
  PROCESS_PAYMENT = 'invoice:process_payment',
  CHANGE_PAYMENT_STATUS = 'invoice:payment_status:change',
  SELECT_DATE = 'invoice:select_date',
  APPOINTMENT_BILLING = 'invoice:appointment_billing',
  CANCEL_BILLING_ITEM = 'invoice:item:cancel',
  CANCEL_INVOICE = 'invoice:cancel',
}

export enum PatientPortalPermType {
  VIEW_PATIENT_ACTIVITY = 'patient:activity:view',
}

export enum AdvancedReportPermType {
  VIEW_REPORT = 'adv:report:view',
}

export enum AdvancedMarketingPermType {
  CREATE_CAMPAIGN = 'adv:marketing:campaign:create',
  VIEW_CAMPAIGN = 'adv:marketing:campaign:view',
}

export enum AnalyticPermType {
  VIEW_ANALYTICS = 'analytics:view',
}

export enum APIIntegrationPermType {
  MANAGE_API = 'api:manage',
  VIEW_API_LOG = 'api:log_view',
  MANAGE_INTEGRATION = 'integrations:manage',
}

export enum FeedbackAndSurveyPermType {
  CREATE_SURVEY = 'survey:create',
  VIEW_SURVEY = 'survey:view',
  ANALYZE_FEEDBACK = 'feedback:analyze',
}

export enum DiagnosisPermType {
  VIEW_DIAGNOSIS = 'diagnosis:view',
  CREATE_DIAGNOSIS = 'diagnosis:create',
  EDIT_DIAGNOSIS = 'diagnosis:edit',
  UPLOAD_DIAGNOSIS = 'diagnosis:upload',
  MANAGE_FAVORITES = 'diagnosis:manage_favorites',
  MANAGE_RECENTS = 'diagnosis:manage_recents',
}

export enum AccountSyncPermType {
  VIEW_ACCOUNT_SYNC = 'account:sync:view',
}

export enum PatientVisitPermType {
  VIEW_VISIT = 'visit:view',
  COMPLETE_VISIT = 'visit:complete',
}

export enum PatientRecordPermType {
  VIEW_RECORD = 'record:view',
  CREATE_RECORD = 'record:create',
  EDIT_RECORD = 'record:edit',
  DELETE_RECORD = 'record:delete',
}

export const PermissionType = {
  ...OrgManagerPermType,
  ...ModulemanagerPermType,
  ...SystemLogPermType,
  ...SubscriptionPermType,
  ...UserPermType,
  ...PatientPermType,
  ...PharmacyPermType,
  ...PrescriptionPermType,
  ...PatientEmrPermType,
  ...AppointmentPermType,
  ...MarketingPermType,
  ...SettingsPermType,
  ...ReportPermType,
  ...AuditLogPermType,
  ...DataPermType,
  ...TeleMedicinePermType,
  ...CommunicationPermType,
  ...RoleManagerPermType,
  ...DocumentPermType,
  ...InvoicePermType,
  ...PatientPortalPermType,
  ...AdvancedReportPermType,
  ...AdvancedMarketingPermType,
  ...AnalyticPermType,
  ...APIIntegrationPermType,
  ...FeedbackAndSurveyPermType,
  ...LeadPermType,
  ...DiagnosisPermType,
  ...AccountSyncPermType,
  ...PremiumPermType,
  ...ServicePermType,
  ...PatientVisitPermType,
  ...PatientRecordPermType,
};

export type PermissionType = typeof PermissionType;
